exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".myreport-item .session-sub-header { float: right; margin-bottom: -20px; margin-top: -5px;}\r\n.myreport-item .session-sub-header li:last-child { margin-right: 0;}\r\n\r\n.myreport-table .dataTables_wrapper { max-height: 525px;}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Work/Projects/OnlineParser/web2-ui/src/app/reports/myReports/charts/charts.component.css
// module id = ../../../../../src/app/reports/myReports/charts/charts.component.css
// module chunks = main